/**
 * The shared browser audio-processing factory (`createAudioContext`) uses the
 * standard or Safari constructor. It returns null when construction is
 * unavailable or fails; callers own and close every returned context.
 */
export function createAudioContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;

  const AudioContextCtor =
    window.AudioContext ??
    (window as typeof window & { webkitAudioContext?: typeof AudioContext })
      .webkitAudioContext;
  if (!AudioContextCtor) return null;
  try {
    return new AudioContextCtor();
  } catch {
    return null;
  }
}
